import React from 'react';
import { Container, Table, Button } from 'react-bootstrap';
import PaginationComponent from '../component/Pagination';
import logoSvg from "../Assets/images/logo.svg";
// import styles from "../Assets/css/electricvehical.module.css"
import styles from "../Assets/css/fleet.module.css"
import Loader from '../component/Loader';
import "../Assets/css/SolArk.css";
import Select from "react-select";
import { useData, US_STATES } from "../context/DataContext";

import { useEffect,useState } from 'react';

const InverterDetails = () => {
    const { utilities: contextUtilities, fetchAllData } = useData();
    const connectInverterlist = process.env.REACT_APP_BASE_URL + 'get/texture/device/?device_type=Inverter';
    const dispatchclikApi = process.env.REACT_APP_BASE_URL + 'texture/device/dispatch/'
    const [loading, setLoading] = useState({
        global: false,
        dispatchbtnn: false,
        dispatchingbtnn: false,
    });

    // Fetch utilities ONLY if not already loaded in context (for direct page access)
    // If coming from Home page, contextUtilities will already be populated - no API call needed
    useEffect(() => {
        const storedAccessToken = localStorage.getItem('accessToken');
        if (storedAccessToken && !contextUtilities) {
            fetchAllData(storedAccessToken);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [inverterData, setinverterData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    // const [is_dispacting, setIsDispacting] = useState(false); 
    const [deviceStatus, setDeviceStatus] = useState({});

    // Date + Hour States
    const [startDate, setStartDate] = useState("");
    const [startHour, setStartHour] = useState("");
    const [endDate, setEndDate] = useState("");
    const [endHour, setEndHour] = useState("");
    const [dateError, setDateError] = useState("");

    // Utility and State Filters
    const [selectedUtility, setSelectedUtility] = useState("All");
    const [selectedState, setSelectedState] = useState("All");

    var [btnvalue = 'Dispatching', setbtnValue] = useState();

    var [InverterbtnValue = 'Dispatch', setinverterbtnValue] = useState();
    const [postsPerPage] = useState(10);
    const onPageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const RefreshThermostatData = async () => {
        try {
            setLoading(true);

            const storedAccessToken = localStorage.getItem('accessToken');
            const response = await fetch(connectInverterlist, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${storedAccessToken}`
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch thermostat data');
            }

            const data = await response.json();
            console.log('inveeter data:', data);
            setinverterData(data);
            setFilteredData(data);
            setLoading(false);

        } catch (error) {
            setLoading(false);

            console.error('Error fetching thermostat data:', error);
        }
    };
    useEffect(() => {

        const fetchData = async () => {
            try {
                setLoading({ ...loading, global: true });

                const storedAccessToken = localStorage.getItem('accessToken');
                if (!storedAccessToken) {
                    throw new Error('Access token not found');
                }

                const response = await fetch(connectInverterlist, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${storedAccessToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }

                const data = await response.json();
                console.log('inverter data:', data);
                setinverterData(data);
                setFilteredData(data);
                setLoading({ ...loading, global: false });
            } catch (error) {
                setLoading({ ...loading, global: false });

                console.error('Error fetching inverter data:', error);
            }
        };
        fetchData();


    }, []);

    // -------- FETCH API (DEFAULT OR FILTERED) -------- //
    const fetchFilteredData = async (start = "", end = "", utility = "All", state = "All") => {
        try {
            setLoading({ ...loading, global: true });

            const storedAccessToken = localStorage.getItem('accessToken');

            // Build API URL with filters
            let apiURL = connectInverterlist;
            const params = [];
            
            if (start && end) {
                params.push(`startdate=${start}`);
                params.push(`enddate=${end}`);
            }
            if (utility && utility !== "All") {
                params.push(`utility=${encodeURIComponent(utility)}`);
            }
            if (state && state !== "All") {
                params.push(`state=${encodeURIComponent(state)}`);
            }
            
            if (params.length > 0) {
                apiURL = `${connectInverterlist}&${params.join('&')}`;
            }

            const response = await fetch(apiURL, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${storedAccessToken}`
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }

            const data = await response.json();
            console.log('Filtered inverter data:', data);
            setinverterData(data);
            setFilteredData(data);
            setLoading({ ...loading, global: false });
        } catch (error) {
            setLoading({ ...loading, global: false });
            console.error('Error fetching filtered data:', error);
            setinverterData([]);
            setFilteredData([]);
        }
    };

    // -------- FILTER -------- //
    const handleFilter = () => {
        // Date validation only if dates are partially filled
        if ((startDate && !endDate) || (!startDate && endDate)) {
            setDateError("Please select both Start Date and End Date");
            return;
        }

        setDateError("");

        let startValue = "";
        let endValue = "";
        
        if (startDate && endDate) {
            startValue = `${startDate}T${startHour || "00:00"}:00`;
            endValue = `${endDate}T${endHour || "23:00"}:00`;
        }

        fetchFilteredData(startValue, endValue, selectedUtility, selectedState);
        setCurrentPage(1);
    };

    // -------- CLEAR -------- //
    const clearFilter = () => {
        setStartDate("");
        setEndDate("");
        setStartHour("");
        setEndHour("");
        setSelectedUtility("All");
        setSelectedState("All");
        setDateError("");
        fetchFilteredData();
    };
    const handleDispatchClick = async (device) => {
        const storedAccessToken = localStorage.getItem('accessToken');
        try {
            setLoading({ ...loading, dispatchbtnn: true });
            const initialData = {
                "status": device.vpp_participations[0].is_dispatching ? 'disable' : 'enable',
                "global": device.vpp_participations[0].is_dispatching,
                "device_type": "Inverter",
                "device_id": device.id,

                // "temperature": 3
            };
            const response = await fetch(dispatchclikApi, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${storedAccessToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(initialData)
            });
            if (!response.ok) {
                throw new Error('Failed to fetch data. Server returned ' + response.status);
            }
            const data = await response.json();
            console.log('Dataaaa', data);
            RefreshThermostatData();
            // const updatedData = inverterData.map(x => {
            //     if (x.id === device.id) {
            //         return {
            //             ...device,
            //             vpp_participations: [
            //                 {
            //                     ...device.vpp_participations[0],
            //                     is_dispatching: true,
            //                     status: "disable"
            //                 }],
            //         }
            //     } else {
            //         return x;
            //     }
            // });
            // setinverterData(updatedData);
            // setinverterbtnValue(InverterbtnValue = "Dispatching");

            // if (deviceType === 'Battery') {
            //     setbtnValue(BatterybtnValue = "Dispatching");
            // } else if (deviceType === 'Thermostat') {
            //     setthemostatbtnValue(ThermostatebtnValue = "Dispatching");
            // } else if (deviceType === 'Vehicle') {
            //     setVehiclebtnValue(VehiclebtnValue = "Dispatching");
            // }
            setDeviceStatus(prevStatus => ({
                ...prevStatus,
                [`dispatching_${device.id}`]: !prevStatus[`dispatching_${device.id}`]
            }));
            setLoading({ ...loading, dispatchbtnn: false }); 
            console.log('After state update', deviceStatus);
        } catch (error) {
            setLoading({ ...loading, dispatchbtnn: false }); 
            console.error('Error:', error.message);
        }
    };
    const handleDispatchingClick = async (device) => {
        const storedAccessToken = localStorage.getItem('accessToken');
        console.log(device, "id")
        try {
            setLoading({ ...loading, dispatchingbtnn: true });
            const initialData = {
                "status": device.vpp_participations[0].is_dispatching ? 'disable' : 'enable',
                "global": false,
                "device_type": "inverter",
                "device_id": device.id,

                // "temperature": 3
            };
            const response = await fetch(dispatchclikApi, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${storedAccessToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(initialData)
            });
            if (!response.ok) {
                throw new Error('Failed to fetch data. Server returned ' + response.status);
            }
            const data = await response.json();
            RefreshThermostatData();
            // console.log('Dataaaa', data);
            // const updatedData = inverterData.map(x => {
            //     if (x.id === device.id) {
            //         return {
            //             ...device,
            //             vpp_participations: [
            //                 {
            //                     ...device.vpp_participations[0],
            //                     is_dispatching: false,
            //                     status: "enable"
            //                 }],
            //         }
            //     } else {
            //         return x;
            //     }
            // });
            // setinverterData(updatedData);

            // console.log('thermostatData ing', updatedData);

            // setthemostatbtnValue(ThermostatebtnValue = "Dispatching");
            // setbtnValue(btnvalue === 'disable' ? "Dispatching" : "Dispatch");
            // if (deviceType === 'Battery') {
            //     setbtnValue(BatterybtnValue = "Dispatching");
            // } else if (deviceType === 'Thermostat') {
            //     setthemostatbtnValue(ThermostatebtnValue = "Dispatching");
            // } else if (deviceType === 'Vehicle') {
            //     setVehiclebtnValue(VehiclebtnValue = "Dispatching");
            // }
            setDeviceStatus(prevStatus => ({
                ...prevStatus,
                [`dispatching_${device.id}`]: !prevStatus[`dispatching_${device.id}`]
            }));
            setLoading({ ...loading, dispatchingbtnn: false });
            console.log('After state update', deviceStatus);
        } catch (error) {
            setLoading({ ...loading, dispatchingbtnn: false });
            console.error('Error:', error.message);
        }
    };
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = filteredData.slice(indexOfFirstPost, indexOfLastPost);



    return (
        <div className={styles.fleet_view_cantaint}>
            {loading && loading.global && <Loader />}


            <section className={styles.topbar}>
                <div className={styles.container}>
                    <img className={styles.topbar_logo} src={logoSvg} alt="Topbar Logo" />
                </div>
            </section>

            <section className="thermostat-details electric-vehicle-details">
                <Container>
                    <h2 className={styles.main_title}>Solar Details</h2>

                    {/* FILTER UI */}
                    <div className="row g-2 mt-3 mb-2 align-items-end">
                        {/* Start Date */}
                        <div className="col-6 col-md-3 ">
                            <label className="small">Start Date</label>
                            <input
                                type="date"
                                min="2025-12-09"
                                className="form-control form-control-sm"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>

                        {/* Start Hour */}
                        <div className="col-6 col-md-2 ">
                            <label className="small">Start Hour</label>
                            <select
                                className="form-control form-control-sm"
                                value={startHour}
                                onChange={(e) => setStartHour(e.target.value)}
                            >
                                <option value="">Hr</option>
                                {Array.from({ length: 24 }).map((_, i) => {
                                    const hr = i.toString().padStart(2, "0");
                                    return (
                                        <option key={i} value={`${hr}:00`}>
                                            {hr}:00
                                        </option>
                                    );
                                })}
                            </select>
                        </div>

                        {/* End Date */}
                        <div className="col-6 col-md-3 ">
                            <label className="small">End Date</label>
                            <input
                                type="date"
                                min="2025-12-09"
                                className="form-control form-control-sm"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>

                        {/* End Hour */}
                        <div className="col-6 col-md-2 ">
                            <label className="small">End Hour</label>
                            <select
                                className="form-control form-control-sm"
                                value={endHour}
                                onChange={(e) => setEndHour(e.target.value)}
                            >
                                <option value="">Hr</option>
                                {Array.from({ length: 24 }).map((_, i) => {
                                    const hr = i.toString().padStart(2, "0");
                                    return (
                                        <option key={i} value={`${hr}:00`}>
                                            {hr}:00
                                        </option>
                                    );
                                })}
                            </select>
                        </div>

                        {/* Utility Filter */}
                        <div className="col-6 col-md-4 ">
                            <label className="small">Utility</label>
                            <Select
                                options={[
                                    { value: "All", label: "All Utility" },
                                    ...(contextUtilities || []).map((utility) => ({
                                        value: utility.id.toString(),
                                        label: utility.utility_name,
                                    })),
                                ]}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        backgroundColor: "#fff",
                                        borderColor: "#b6b6b6",
                                        minHeight: "31px",
                                        height: "31px",
                                        boxShadow: "none",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        color: "#4c2806",
                                        borderRadius: "3px",
                                        cursor: "pointer"
                                    }),
                                    valueContainer: (provided) => ({
                                        ...provided,
                                        height: "31px",
                                        padding: "0 6px",
                                        display: "flex",
                                        alignItems: "center"
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: "#4c2806",
                                        position: "relative",
                                        top: "auto",
                                        transform: "none",
                                        margin: 0,
                                        maxWidth: "100%",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        margin: "0px",
                                        padding: "0px"
                                    }),
                                    indicatorSeparator: () => ({
                                        display: "none",
                                    }),
                                    indicatorsContainer: (provided) => ({
                                        ...provided,
                                        height: "31px",
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        fontSize: "13px",
                                        color: "#4c2806"
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected ? "#ffe0b2" : state.isFocused ? "#fff7e9" : "white",
                                        color: "#4c2806",
                                        cursor: "pointer"
                                    })
                                }}
                                value={
                                    selectedUtility === "All"
                                        ? { value: "All", label: "All Utility" }
                                        : (contextUtilities || []).map(u => ({ value: u.id.toString(), label: u.utility_name })).find(opt => opt.value === selectedUtility)
                                }
                                onChange={(option) => setSelectedUtility(option ? option.value : "All")}
                                placeholder="Select Utility"
                                isSearchable
                                isClearable
                            />
                        </div>

                        {/* State Filter */}
                        <div className="col-6 col-md-4">
                            <label className="small">State</label>
                            <Select
                                options={[
                                    { value: "All", label: "All States" },
                                    ...US_STATES.map((state) => ({ value: state, label: state })),
                                ]}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        backgroundColor: "#fff",
                                        borderColor: "#b6b6b6",
                                        minHeight: "31px",
                                        height: "31px",
                                        boxShadow: "none",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        color: "#4c2806",
                                        borderRadius: "3px",
                                        cursor: "pointer"
                                    }),
                                    valueContainer: (provided) => ({
                                        ...provided,
                                        height: "31px",
                                        padding: "0 6px",
                                        display: "flex",
                                        alignItems: "center"
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: "#4c2806",
                                        position: "relative",
                                        top: "auto",
                                        transform: "none",
                                        margin: 0,
                                        maxWidth: "100%",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        margin: "0px",
                                        padding: "0px"
                                    }),
                                    indicatorSeparator: () => ({
                                        display: "none",
                                    }),
                                    indicatorsContainer: (provided) => ({
                                        ...provided,
                                        height: "31px",
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        fontSize: "13px",
                                        color: "#4c2806"
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected ? "#ffe0b2" : state.isFocused ? "#fff7e9" : "white",
                                        color: "#4c2806",
                                        cursor: "pointer"
                                    })
                                }}
                                value={
                                    selectedState === "All"
                                        ? { value: "All", label: "All States" }
                                        : { value: selectedState, label: selectedState }
                                }
                                onChange={(option) => setSelectedState(option ? option.value : "All")}
                                placeholder="Select State"
                                isSearchable
                                isClearable
                            />
                        </div>

                        {/* Buttons */}
                        <div className="col-12 col-md-4 d-flex gap-2 mt-md-0 mt-2">
                            <button
                                className="btn btn-primary btn-sm filter-button"
                                onClick={handleFilter}
                                style={{backgroundColor: '#ff5900', borderColor: '#ff5900', color: '#fff'}}
                            >
                                Filter
                            </button>
                            <button
                                className="btn btn-secondary btn-sm filter-button"
                                onClick={clearFilter}
                            >
                                Clear
                            </button>
                        </div>
                    </div>

                    {dateError && <div style={{ color: "red" }}>{dateError}</div>}

                    <div className="table-responsive mt-4">
                        <Table className={styles.table}>
                            <thead>
                                <tr>
                                    <th >Device ID</th>
                                    <th className="text-center">User</th>
                                    <th className="text-center">Device ZIP</th>
                                    <th className="text-center">Production (kWh)</th>
                                    <th className="text-center">Consumption (kWh)</th>
                                    <th className="text-center">Battery State</th>
                                    <th className="text-center">Dispatching?</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentPosts.map((device, index) => (
                                    <tr key={index}>
                                        <td>{device.external_device_id}</td>
                                        <td className="text-center">{device.owner?.first_name && device.owner?.last_name ? `${device.owner.first_name} ${device.owner.last_name}` : device.owner?.email || 'N/A'}</td>
                                        <td className="text-center">{device.owner_address?.zip_code || 'N/A'}</td>
                                        <td className="text-center">{device.energy ? device.energy.production : 'N/A'}</td>
                                        <td className="text-center">{device.energy ? device.energy.consumption : 'N/A'}</td>
                                        <td className="text-center">{device.battery_state || 'Unknown'}</td>
                                        <td className="text-center">
                                          
                                            {device.vpp_participations && device.vpp_participations.length > 0 ? (
                                                device.vpp_participations[0].status ? (
                                                    device.vpp_participations[0].is_dispatching ? (
                                                        <>
                                                            {loading && loading.dispatchingbtnn && <Loader />}
                                                        <button className={styles.buttondispaching} onClick={() => handleDispatchingClick(device)} style={{ backgroundColor: btnvalue === 'Dispatch' ? 'rgba(94, 248, 132, 1)' : '', color: btnvalue === 'Dispatch' ? 'black' : '' }}>{btnvalue}</button>
                                                        </>) : (
                                                            <> {loading && loading.dispatchbtnn && <Loader />}
                                                        {/* <button className={styles.dispachbtn} onClick={() => handleDispatchClick(device)}
                                                                style={{ backgroundColor: InverterbtnValue === 'Dispatching' ? 'white' : '', color: InverterbtnValue === 'Dispatching' ? 'blue' : '' }}
                                                                > {InverterbtnValue}</button></> */}
                                                                <button className={styles.dispachbtn} onClick={() => handleDispatchClick(device)}
                                                                    style={{ backgroundColor: device.vpp_participations && device.vpp_participations[0].is_dispatching ? 'white' : '', color: device.vpp_participations && device.vpp_participations[0].is_dispatching ? 'blue' : '' }}
                                                                > {device.vpp_participations && device.vpp_participations[0].is_dispatching ? 'Dispatching' : 'Dispatch'}</button>
</>
                                                    )
                                                ) : (
                                                    <button className={styles.dispachbtndisabled} disabled>Disabled</button>
                                                )
                                            ) : (
                                                <button className={styles.dispachbtndisabled} disabled>Disabled</button>
                                            )}
                                           </td>
                                    </tr>
                                ))}
                            </tbody>
                           
                        </Table>
                    </div>
                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={Math.ceil(filteredData.length / postsPerPage)}
                        onPageChange={onPageChange}
                    />
                </Container>
            </section>
        </div>
    );
};

export default InverterDetails;
